import { ChangeEventHandler } from 'react'
import { Box, Fade, Stack, useTheme } from '@mui/material'
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material'

import { TextBold, TextParagraph } from 'presentation/components/elements'
import {
  activeText,
  displayRepresentativesText,
  hideText,
  youCanEnableOrDisableTheDisplayText,
} from 'presentation/constant/texts/goalAssignment'
import { StyledTooltip } from 'presentation/styles/index.styled'
import { AntSwitch } from './index.styled'

type CustomizedSwitchesProps = {
  isChecked: boolean
  handleChangeSwitch: ChangeEventHandler
  name: string
  isShowText?: boolean
  isDisabled?: boolean
}

export default function CustomizedSwitches({
  isChecked,
  handleChangeSwitch,
  name,
  isShowText = true,
  isDisabled = false,
}: CustomizedSwitchesProps) {
  const theme = useTheme()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {isShowText && (
        <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
          <TextBold
            color={theme.palette.info.main}
            fontSize="11px"
            lineHeight="12.89px"
            fontWeight={600}
          >
            {displayRepresentativesText}
          </TextBold>
          <StyledTooltip
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            title={youCanEnableOrDisableTheDisplayText}
          >
            <InfoOutlinedIcon color="info" fontSize="small" />
          </StyledTooltip>
        </Box>
      )}
      <Stack direction="row" spacing={1} alignItems="center">
        {isShowText && (
          <TextParagraph fontWeight={300} fontSize="11px" lineHeight="12.89px">
            {hideText}
          </TextParagraph>
        )}
        <AntSwitch
          inputProps={{ 'aria-label': 'ant design' }}
          checked={isChecked}
          onChange={handleChangeSwitch}
          name={name}
          disabled={isDisabled}
        />
        {isShowText && (
          <TextParagraph fontWeight={300} fontSize="11px" lineHeight="12.89px">
            {activeText}
          </TextParagraph>
        )}
      </Stack>
    </Box>
  )
}
